import { render, staticRenderFns } from "./SimpleStackedBar.vue?vue&type=template&id=b9e224b2&scoped=true"
import script from "./SimpleStackedBar.vue?vue&type=script&lang=js"
export * from "./SimpleStackedBar.vue?vue&type=script&lang=js"
import style0 from "./SimpleStackedBar.vue?vue&type=style&index=0&id=b9e224b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e224b2",
  null
  
)

export default component.exports